import React from 'react'

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'

const styles = {
    root : {
        marginTop : 6,
        color: '#676767',
    },
    select : {
        border: '1px solid #C7C7C7',
        padding : 8,
        paddingLeft: 5,
        paddingBottom: 9,
        color: '#676767',
        backgroundColor : '#fff',
    },
    disabled : {
        color : '#9E9E9E',
        backgroundColor : '#FCFCFC'
    },
    textField : {
        marginTop: 0,
    },
    input : {
        border: '1px solid #C7C7C7',
        paddingLeft: 5,
        color: '#676767',
        marginTop: 6,
        backgroundColor : '#fff',
    },
    label : {
        color : '#3CA7AC',
        fontSize : 18,
        fontWeight: 600,
        textTransform: 'capitalize',
    },
    labelDisabled : {
        color : '#9E9E9E'
    }
}

const SelectInput = ({
    id,
    input,
    label,
    meta: { touched, invalid, error },
    children,
    classes,
    disabled,
    ...custom
}) => {
  const selectClasses = {
    root: classes.root,
    select: classes.select,
    disabled: classes.disabled
  }
  
  return (
    <FormControl error={touched && invalid && error} fullWidth>
        <InputLabel
            classes={{ root : classes.label }}
            shrink={true}
            htmlFor={id}
            disabled={disabled}
        >
            {label}
        </InputLabel>
        <Select
            classes={selectClasses}
            inputProps={{
                name: input.name,
                id: id,
            }}
            displayEmpty={false}
            disabled={disabled}
            {...input}
            {...custom}
        >
            {children}
        </Select>
        {(touched && invalid && error) &&
        <FormHelperText>{error}</FormHelperText>}
    </FormControl>
)}

export default withStyles(styles)(SelectInput)
